import React from 'react';
import { Info } from 'lucide-react';

/** A small "i" icon that reveals a plain-English explanation on hover/focus. */
const InfoHint: React.FC<{ text: string; size?: number }> = ({ text, size = 13 }) => (
  <span className="mx-info" tabIndex={0} aria-label={text}>
    <Info size={size} strokeWidth={2} />
    <span className="mx-info-bubble" role="tooltip">{text}</span>
  </span>
);

export default InfoHint;
